import * as React from 'react';
import { QuantitySelector } from '@grandvisionhq/common';
import { Hr } from '@grandvisionhq/elements';
import { useProductDetailSlots, useCmsData, ProductDetailTitleView, StickyAside, ProductDetailUsps, ProductDetailDisclaimer } from '@grandvisionhq/fun-products';
import { StockIndicator } from '@grandvisionhq/inventory';
import { ReviewSnippet } from '@grandvisionhq/reviews';
import { useIntl } from '@grandvisionhq/state';
import { getCalculatedMaximumQuantity } from '@grandvisionhq/utils';
import { SolutionsEcommProvider } from './context/SolutionsEcommContext.js';
import { ProductImageGalleryContainer } from '../../ProductImageGallery/ProductImageGalleryContainer.js';
import { ProductLabelTag } from '../Components/ProductLabelTag/ProductLabelTag.js';
import { SolutionsPriceSection } from './Components/SolutionsPriceSection/SolutionsPriceSection.js';
import { PackageSelector } from './Components/PackageSelector/PackageSelector.js';
import { SolutionsSubscriptionPurchase } from './Components/SolutionsSubscriptionPurchase/SolutionsSubscriptionPurchase.js';
import { SolutionsStickyCTA } from './Components/SolutionsStickyCTA/SolutionsStickyCTA.js';
import { Description } from './Components/Description/Description.js';

const Solutions = ({ addToCartRef , availableQuantity , ctaButton , brandLink , isSmallScreen , showStickyButton , variant , variants , brandModel , selectedQuantity , onDecreaseQuantity , onIncreaseQuantity , isOrderable , maxOrderableQuantity , allowBackOrder ,  })=>{
    var ref;
    const { getLabel  } = useIntl();
    const { Slots  } = useProductDetailSlots();
    const { disclaimer  } = useCmsData();
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__main product-detail-solutions"
    }, isSmallScreen && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__header--mobile"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${variant.modelName} ${brandModel}`,
        subtitle: variant.brand,
        href: brandLink,
        sku: variant.sku
    }), /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: variant.sku
    })), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__image-gallery"
    }, /*#__PURE__*/ React.createElement(ProductImageGalleryContainer, null)), /*#__PURE__*/ React.createElement("section", {
        className: "product-detail__aside",
        "aria-label": `${variant.modelName} ${variant.modelName}`
    }, /*#__PURE__*/ React.createElement(StickyAside, {
        bottomBoundary: ".product-detail",
        isEnabled: !isSmallScreen
    }, /*#__PURE__*/ React.createElement(SolutionsEcommProvider, null, /*#__PURE__*/ React.createElement("div", {
        className: "mobile-hidden"
    }, /*#__PURE__*/ React.createElement(ProductDetailTitleView, {
        title: `${variant.modelName} ${brandModel}`,
        subtitle: variant.brand,
        href: brandLink,
        sku: variant.sku
    })), ((ref = variant.tag) === null || ref === void 0 ? void 0 : ref.value) && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__product-tag"
    }, /*#__PURE__*/ React.createElement(ProductLabelTag, null)), !!variant.price && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SolutionsPriceSection, {
        className: "product-detail__specification-prices"
    }), Slots.AfterPrice ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__after-price-slot"
    }, /*#__PURE__*/ React.createElement(Slots.AfterPrice, null)) : null), !isSmallScreen && /*#__PURE__*/ React.createElement(ReviewSnippet, {
        className: "product-detail__review-snippet",
        productId: variant.sku
    }), /*#__PURE__*/ React.createElement(PackageSelector, {
        variants: variants,
        className: "product-detail-solutions__package-selector"
    }), /*#__PURE__*/ React.createElement(SolutionsSubscriptionPurchase, {
        className: "product-detail-solutions__subscription"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__quantity-picker"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__quantity-picker__label"
    }, getLabel('products.solutions.selectAmount')), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__quantity-picker__wrapper"
    }, /*#__PURE__*/ React.createElement(QuantitySelector, {
        quantity: selectedQuantity || 1,
        minimumQuantity: 1,
        maximumQuantity: getCalculatedMaximumQuantity(maxOrderableQuantity, availableQuantity, allowBackOrder),
        onDecreaseQuantity: onDecreaseQuantity,
        onIncreaseQuantity: onIncreaseQuantity,
        isDisabled: !isOrderable
    }), /*#__PURE__*/ React.createElement(StockIndicator, {
        stockCount: availableQuantity,
        allowBackOrder: isOrderable,
        channelAvailability: variant.channelAvailability
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__cart-details"
    }, Slots.DynamicDeliveryIndicator ? /*#__PURE__*/ React.createElement(Slots.DynamicDeliveryIndicator, {
        deliveryItems: [
            {
                sku: variant.sku,
                quantity: selectedQuantity || 1
            }
        ],
        isExcludedFromCheckout: variant.excludedFromCheckout
    }) : null, /*#__PURE__*/ React.createElement("div", {
        ref: addToCartRef
    }, ctaButton), Slots.AfterCTA ? /*#__PURE__*/ React.createElement(Slots.AfterCTA, null) : null), isSmallScreen && showStickyButton && /*#__PURE__*/ React.createElement(SolutionsStickyCTA, {
        ctaButton: ctaButton
    }), /*#__PURE__*/ React.createElement(Hr, {
        className: "product-detail__usp-divider"
    }), /*#__PURE__*/ React.createElement(ProductDetailUsps, {
        className: "product-detail__usps"
    })))), /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-solutions__description"
    }, /*#__PURE__*/ React.createElement(Description, null)), disclaimer && /*#__PURE__*/ React.createElement("div", {
        className: "product-detail__disclaimer product-detail-lenses__disclaimer"
    }, /*#__PURE__*/ React.createElement(ProductDetailDisclaimer, null)));
};
var Solutions$1 = Solutions;

export { Solutions, Solutions$1 as default };
//# sourceMappingURL=Solutions.js.map
